import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import type { ContactTrainingPurchase } from '@/lib/contacts/types'
import { displayDate } from '@/lib/dates'

/** Training an organisation was invoiced for that names this person as the purchaser. */
export function ContactTrainingPurchased({
  purchases,
}: {
  purchases: ContactTrainingPurchase[] | undefined
}) {
  if (!purchases?.length) return null
  return (
    <Card role="region" aria-labelledby="training-purchased-heading">
      <CardHeader className="p-4 pb-0">
        <CardTitle id="training-purchased-heading" className="text-body font-semibold">
          Training purchased
        </CardTitle>
      </CardHeader>
      <CardContent className="p-4 pt-2">
        <ul className="divide-y divide-border">
          {purchases.map((purchase) => (
            <li key={purchase.id} className="space-y-1 py-3 first:pt-1 last:pb-0">
              <div className="flex items-baseline justify-between gap-3">
                <span className="font-medium text-foreground">
                  {purchase.course?.name ?? purchase.description}
                </span>
                <span className="tabular-nums text-foreground">{purchase.amount}</span>
              </div>
              <p className="flex flex-wrap gap-x-1.5 text-caption text-muted-foreground">
                <span>Purchased by {purchase.purchaser?.display_name}</span>
                <span aria-hidden="true">·</span>
                <span>
                  Billed to{' '}
                  <Button variant="link" size="inline" asChild className="text-caption">
                    <a href={`/contacts/organizations/${purchase.billed_to.id}`}>
                      {purchase.billed_to.name}
                    </a>
                  </Button>
                </span>
                <span aria-hidden="true">·</span>
                <Button variant="link" size="inline" asChild className="text-caption">
                  <a href={`/finance/invoices/${purchase.invoice.id}`}>
                    Invoice #{purchase.invoice.number}
                  </a>
                </Button>
                <span aria-hidden="true">·</span>
                <span>{displayDate(purchase.issue_on)}</span>
                <span aria-hidden="true">·</span>
                <span>{purchase.status}</span>
              </p>
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  )
}
